import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms/forms";
import { HttpErrorResponse } from "@angular/common/http";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClassroomrequestService } from './classroomrequest.service';
import { global } from '../../shared/global';
import { ClassRoomRequest } from '../Models/classrooomrequest.model';
import { schoolfullregistrationrequestService } from '../School/schoolfullregistrationrequest/schoolfullregistrationrequest.service';
declare var $: any;

@Component({
  selector: 'app-classroomrequest',
  templateUrl: './classroomrequest.component.html',
  styleUrls: ['./classroomrequest.component.css']
})
export class ClassroomrequestComponent implements OnInit {

  @ViewChild('classroomdetailreq') classroomdetailreq : NgForm;
  searchtext;
  isDesc: boolean;
  column: string;
  p: number = 1;
  pageLimit = global.pageLimit;
  responseData: any;
  dropDownData: any;
  data: ClassRoomRequest;
  submitted: boolean;
  btnsubmittext = "Add";
  ClassRoomRequestList:any;
  ClassroomDetail: Array<any> = [];
  totalClass:any;
  totalPages = 10;
  
  constructor(private service: ClassroomrequestService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService, private rout: ActivatedRoute) { }


  ngOnInit(): void {
    if (localStorage.length == 0 || localStorage.getItem("token") == "" || localStorage.getItem("token") == undefined) {
      this.router.navigate(['/collegelogin']);
      return;
    }
    document.getElementById('YearID').addEventListener('change', () => {
      this.GetClassRoomList(this.p);
});
    this.data = new ClassRoomRequest();
    $("#searchtext").val("");
    this.GetClassRoomList(this.p);
  }
  GetClassRoomList(page) {
    this.p = page;
    var search = "";
    if($("#searchtext").val() != undefined || $("#searchtext").val() != null || $("#searchtext").val() != ""){
      search = $("#searchtext").val();
    }
    const data = {
      YearID: +localStorage.getItem("yearID"),
      SearchText : search,
      OffSet : (this.p - 1) * this.pageLimit,
      pagelimit : this.pageLimit
    };
    this.service.getClassRoomDetailRequestList(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        this.ClassRoomRequestList = [];
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          //this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.ClassRoomRequestList = this.responseData.classRoomDetailRequestList;
          this.totalClass = this.responseData.totalCount;
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }
  validateClassroomDetail() {
    this.ClassroomDetail = [];
    for (var x = 0; x < this.data.NoOfClassRoom; x++) {
      var classroomname = $("#classroomname" + x).val();
      var classroomsize = $("#classroomsize" + x).val();
      if (classroomname == undefined || classroomname.trim().length <= 0) {
        this.toastr.error("classroom name is requied")
        return false;
      }
      if (classroomsize == undefined || classroomsize.toString().trim().length == 0) {
        this.toastr.error("classroom size is requied")
        return false;
      }
      this.ClassroomDetail.push({ "ClassroomName": classroomname, "ClassroomSize": classroomsize })
    }
    this.data.ClassroomDetail = this.ClassroomDetail;
    return true;
  }
  onSubmit(data){
    this.submitted = true;
    if (this.data.NoOfClassRoom == 0) {
      this.toastr.error("No of classroom is required");
      return;
    }
    var z = this.validateClassroomDetail();
    if (z == false) {
      return;
    }
    if (this.classroomdetailreq.valid) {
      this.data.YearID = Number(localStorage.getItem("yearID"));
      this.spinner.show();
      this.service.saveClassRoomRequest(this.data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
            this.router.navigate(['/collegelogin']);
            return
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.GetClassRoomList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }

  editClassRoomRequest(HashCode) {
    this.spinner.show();
    const data = {
      HashCode: HashCode
     
    };
    this.service.getClassRoomRequestByID(data)
      .subscribe(data => {
        this.responseData = data;
        this.spinner.hide();
        if (this.responseData.tokenStatus == false) {
          this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
        }
        if (this.responseData.status == false) {
          this.toastr.error(this.responseData.message);
          return
        }
        else {
          this.spinner.hide();
          this.data = this.responseData;
          this.ClassroomDetail = this.data.ClassroomDetail;
          this.spinner.show();
          setTimeout(() => { this.fillClassRooms(); this.spinner.hide(); }, 500);
          this.btnsubmittext = "Update";
        }
      }, (err: HttpErrorResponse) => {
        localStorage.clear();
        this.spinner.hide();
        this.toastr.error('Something Went Wrong');
        this.router.navigate(['/collegelogin']);
      });
  }
  deleteClassRoomRequest(HashCode) {
    var a = confirm("Are you sure you want to delete ?");
    if (a) {
      const data = {
        HashCode: HashCode
      }
      this.spinner.show();
      this.service.deleteClassRoomRequest(data)
        .subscribe(data => {
          this.responseData = data;
          this.spinner.hide();
          if (this.responseData.tokenStatus == false) {
            this.toastr.error(this.responseData.message);
          this.router.navigate(['/collegelogin']);
          return
          }
          if (this.responseData.status == false) {
            this.toastr.error(this.responseData.message);
            return
          }
          else {
            this.toastr.success(this.responseData.message);
            this.GetClassRoomList(this.p);
            this.resetForm();
          }
        }, (err: HttpErrorResponse) => {
          localStorage.clear();
          this.spinner.hide();
          this.toastr.error('Something Went Wrong');
          this.router.navigate(['/collegelogin']);
        });
    }
  }
  fillClassRooms() {
    if (this.data.NoOfClassRoom > 0) {
      $("#divClassRoom").html('');
      this.spinner.show();
      for (var j = 0; j < this.data.NoOfClassRoom; j++) {
        var t: string;
        if (j == 0) {
          t = '<div class="p-2 m-2" style="border: 1px solid black"> ';
        }
        var roomname= "";
        var roomsize= "";
        if(this.data.ClassroomDetail != undefined && this.data.ClassroomDetail[j] != undefined)
        {
          if(this.data.ClassroomDetail[j]["ClassroomName"] !=  undefined)
            roomname = this.data.ClassroomDetail[j]["ClassroomName"]

          if(this.data.ClassroomDetail[j]["ClassroomSize"] !=  undefined)
            roomsize = this.data.ClassroomDetail[j]["ClassroomSize"]
        }
        t += '<div class="row mt-2"> ' +
          '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
          ' <label><b>Classroom name</b><span class="text-danger">*</span></label> ' +
          ' <input name="classroomname' + j + '" id="classroomname' + j + '" autocomplete="off" class="form-control" type="text" value="'+ roomname +'" placeholder="Enter classroom name" maxlength="50"  /> ' +
          '</div>' +
          '<div class="form-group col-lg-4 col-md-12 col-12"> ' +
          ' <label><b>Classroom size (Format : Length x Width)</b><span class="text-danger">*</span></label> ' +
          ' <input type="text" class="form-control" name="classroomsize' + j + '" autocomplete="off" id="classroomsize' + j + '" value="'+ roomsize +'" placeholder="Enter classroom size (Format : Length x Width)"  maxlength="15" /> ' +
          '</div>' +
          '</div>';
      }
      t += '</div>';
      $("#divClassRoom").append(t);
      this.spinner.hide();
    }
  }
  resetForm() {
    this.data.ID = 0;
    this.data.NoOfClassRoom = null;
    $("#divClassRoom").html('');
    this.data.ClassroomDetail = [];
    this.ClassroomDetail = [];
    this.submitted = false;
    this.classroomdetailreq.resetForm();
    this.btnsubmittext = "Add";
  }
  sortBy(field: string) {
    this.isDesc = !this.isDesc;
    this.column = field;
    let direction = this.isDesc ? 1 : -1;

    this.ClassRoomRequestList.sort(function (a, b) {
      if (a[field] < b[field]) {
        return -1 * direction;
      }
      else if (a[field] > b[field]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }

  setpage() {
    this.p = 1;
  }
}
